module.exports = __webpack_public_path__ + "img/cy.039a34d8.svg";